import * as types from '../utils/mutation-types.js'
import {
  setSessionStore
} from '../utils/storage.js'

const state = {
  accessToken: null,
  refreshToken: null,
  shainNo: null,
  shainName: '',
  authLevel: null
}

const mutations = {
  [types.ACCESS_TOKEN] (state, { token }) {
    // api.header(token)
    setSessionStore('ACCESS_TOKEN', token)
  },
  [types.SHAIN_NO] (state, { num }) {
    state.shainNo = num
  },
  [types.SHAIN_NAME] (state, { name }) {
    state.shainName = name
  },
  [types.AUTH_LEVEL] (state, { auth }) {
    state.authLevel = auth
  }
}

const getters = {
  getShainName: state => state.shainName,
  getAccessToken: state => state.accessToken
}

const actions = {
  [types.ACCESS_TOKEN] ({ commit }, token) {
    commit(types.ACCESS_TOKEN, { token })
  },
  [types.SHAIN_NO] ({ commit }, num) {
    commit(types.SHAIN_NO, { num })
  },
  [types.SHAIN_NAME] ({ commit }, name) {
    commit(types.SHAIN_NAME, { name })
  },
  [types.AUTH_LEVEL] ({ commit }, auth) {
    commit(types.AUTH_LEVEL, { auth })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js